import { BonusEnginePromo, GenericPromo, PromoStatus, Promotion, PromotionWithTheme } from '../types';

/**
 * Cross checks the promotions from the bonus engine with the promohub.
 * If a promotion is segmented, it will only be displayed if it is configured in the bonus engine.
 * If a promotion is not segmented, it will always be displayed (generic promotion).
 */
export const getPromotionsToDisplay = (
    bonusEnginePromos: BonusEnginePromo[] | undefined,
    promohub: PromotionWithTheme[] | undefined,
    genericPromosStatus: GenericPromo[]
): Promotion[] => {
    if (!promohub || promohub.length === 0) {
        return [];
    }

    const promos: Promotion[] = [];

    promohub.forEach(promotion => {
        const isSegmented = promotion.data.segmented;
        if (isSegmented) {
            if (!bonusEnginePromos) {
                return;
            }
            const bonusEnginePromo = bonusEnginePromos.find(it => it.promoSlug === promotion.uid);
            if (bonusEnginePromo) {
                promos.push({
                    ...promotion,
                    bonusEngineDetails: bonusEnginePromo,
                    optedIn: !!bonusEnginePromo.optedInTime,
                });
            }
        } else {
            promos.push({
                ...promotion,
                optedIn: genericPromosStatus?.find(p => p.gameId === promotion.uid)?.status === PromoStatus.OPTED_IN,
            });
        }
    });

    return promos;
};
